import { chakra, defineRecipe } from '@plurall/elo-v3';

// Provides horizontal and block-end padding consistent with EloHeaderPage's own padding,
// so page content aligns with the header. Replaces the padding that was previously
// baked into ContentFactory. Pages that use EloHeaderPage wrap their content in this.
// TODO: migrate other pages that lost padding when ContentFactory was zeroed out.
export const PageContent = chakra(
  'div',
  defineRecipe({
    className: 'page-content',
    base: {
      paddingInline: 'padding.large',
      paddingBlockEnd: 'padding.4xlarge',
      sm: {
        paddingInline: 'padding.2xlarge',
      },
    },
  })
);
